import { React, DomeComponent, DomeManipulator } from "@lexriver/dome";
import css from './TextArea.m.scss'
import { ErrorForInput } from "./ErrorForInput";

interface Attrs{
    value?:string
    placeholder?:string
    sessionStorageKey?:string
}

export class TextArea extends DomeComponent<Attrs>{
    private errorForInput:ErrorForInput|undefined 
    private textarea:HTMLTextAreaElement|undefined

    render(){
        if(this.attrs.sessionStorageKey){
            this.attrs.value = sessionStorage.getItem(this.attrs.sessionStorageKey) || this.attrs.value || ''
        }

        return <div class={css.textarea}>
            <textarea ref={ref => this.textarea = ref} placeholder={this.attrs.placeholder} onBlur={e => this.onBlur(e)}>{this.attrs.value || ''}</textarea>
            <ErrorForInput ref={ref => this.errorForInput = ref} />
        </div>
    }

    async hideErrorAsync(){
        if(!this.errorForInput) return
        await this.errorForInput.hideAsync()
    }

    async showErrorAsync(errorMessage:string|HTMLElement){
        if(!this.errorForInput) return
        if(!this.textarea) return
        await this.errorForInput.showAsync(errorMessage)
        DomeManipulator.scrollIntoView(this.textarea)
    }

    getValue(){
        if(!this.textarea) return
        return this.textarea.value
    }

    setValue(newValue:string|number|null|undefined){
        if(newValue === undefined) newValue = ''
        else if(newValue === null) newValue = ''
        newValue = newValue.toString()
        this.attrs.value = newValue
        if(!this.textarea) return
        this.textarea.value = newValue
        this.saveValueToSessionStorage()
    }

    protected saveValueToSessionStorage(){
        if(this.attrs.sessionStorageKey){
            sessionStorage.setItem(this.attrs.sessionStorageKey, this.getValue() || '')
        }

    }

    onBlur(e){
        //console.log('on blur!', this.textarea!.value)
        this.saveValueToSessionStorage()
    }

    focus(){
        if(this.textarea) this.textarea.focus()
    }

    disable(){
        if(this.textarea) this.textarea.disabled = true
    }

    enable(){
        if(this.textarea) this.textarea.disabled = false
    }

}